// Device Tester environment constants
export const APP_NAME = "DeviceTester";
export const APP_ENV = "canary";

// EHR Service constants
export const EHR_SERVICE_DOMAIN = "ehrconnectorsvc-canary.teams.microsoft";
export const ALLOWED_EHR_SERVICE_DOMAINS = [
  "ehrconnectorsvc-canary.teams.microsoft.com",
];
export const EHR_SERVICE_PATH = "/api/graphql/v1";
export const PRIVACY_TERMS_URL =
  "https://go.microsoft.com/fwlink/?LinkId=521839";

// ACS service constants
export const ACS_SERVICE_BASE_URL = "https://visitstaging.teams.microsoft.com";
export const ACS_SERVICE_TOKEN_PATH = "webrtc-svc/api/token";
export const ACS_TEST_CALL_ID = "8:echo123";

// Launch source constraints
export const ALLOWED_LAUNCH_SOURCES = ["epic", "test"];
